import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { GenerateChartIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Flex } from 'foundations-components/components/Flex';
import TruncateToRowLimit from 'reporting-discover-components/components/shared/TruncateToRowLimit';
import { MISSING_SUBAPP_DESCRIPTIONS, SUBAPP_KEY_TO_ICON, TAB_ID_TO_ICON } from '../../config/collectionHomes';
import { useCallback, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import SideNavReRenderContext from '../../records/SideNavReRenderContext';
// @ts-expect-error Untyped import
import { trackEvent } from '../../lib/usageTracker';
import HomesCardSection from './HomesCardSection';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TruncateTwoRow = styled(props => /*#__PURE__*/_jsx(TruncateToRowLimit, Object.assign({
  rowLimit: 2
}, props))).withConfig({
  displayName: "DescriptiveReportCard__TruncateTwoRow",
  componentId: "ing7mk-0"
})(["color:", ";font-weight:", ";font-size:", ";text-align:left;"], ({
  theme
}) => theme.color['fill-accent-neutral-default'], ({
  theme
}) => theme.typography['body-100'].fontWeight, ({
  theme
}) => theme.typography['body-100'].fontSize);

// SelectableBox defaults all text to a larger font size so we need to override it here
const TextSizeFriendlyDiv = styled.div.withConfig({
  displayName: "DescriptiveReportCard__TextSizeFriendlyDiv",
  componentId: "ing7mk-1"
})(["font-size:", ";"], ({
  theme
}) => theme.typography['body-100'].fontSize);
const DescriptiveReportCard = ({
  children,
  ['data-test-id']: dataTestId,
  includeDescription,
  name,
  onClick = () => {},
  subAppKey,
  tabId,
  trackingEvent,
  useCompact = false
}) => {
  const {
    categoryId: subSuiteId,
    collectionId: suiteId
  } = useParams();
  const {
    sideNavReRender,
    updateSideNavReRender
  } = useContext(SideNavReRenderContext);
  const history = useHistory();
  const TabIcon = tabId && TAB_ID_TO_ICON[tabId];
  const SubAppIcon = SUBAPP_KEY_TO_ICON[subAppKey] || GenerateChartIcon;
  const descriptionKey = MISSING_SUBAPP_DESCRIPTIONS[subAppKey] || `reports.suiteContents.${subAppKey}.description`;
  const handleClick = useCallback(() => {
    trackEvent(trackingEvent, {
      source: subAppKey,
      interactionSource: subSuiteId || suiteId,
      whichStage: subSuiteId ? 'sub-collection-home' : 'collection-home'
    });
    onClick();
    updateSideNavReRender(!sideNavReRender);
    const queryParams = tabId ? `?tab=${tabId}` : '';
    history.push(`/templates/${suiteId}/${subAppKey}${queryParams}`);
  }, [history, onClick, sideNavReRender, subSuiteId, suiteId, updateSideNavReRender, subAppKey, tabId, trackingEvent]);
  const title = name || /*#__PURE__*/_jsx(FormattedMessage, {
    message: `reports.suiteContents.${subAppKey}.title`
  });
  const TitleWithIcon = /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      paddingInlineStart: "0",
      paddingBlock: "0",
      icon: TabIcon || SubAppIcon,
      color: "fill-accent-purple-default"
    }), /*#__PURE__*/_jsx(TruncateString, {
      placement: "bottom",
      textAlign: "left",
      children: title
    })]
  });
  if (useCompact) {
    return /*#__PURE__*/_jsx(SelectableBox, {
      onClick: handleClick,
      paddingBlock: "250",
      paddingInline: "500",
      type: "default",
      "data-test-id": dataTestId,
      children: /*#__PURE__*/_jsx(Text, {
        typography: "heading-50",
        children: TitleWithIcon
      })
    });
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(SelectableBox, {
      onClick: handleClick,
      type: "default",
      padding: "0",
      "data-test-id": dataTestId,
      paddingBlockEnd: "200",
      children: [/*#__PURE__*/_jsxs(HomesCardSection, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h5",
          truncate: true,
          marginBlockEnd: children ? '400' : '0',
          children: TitleWithIcon
        }), includeDescription && /*#__PURE__*/_jsx(TruncateTwoRow, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: descriptionKey
          })
        })]
      }), /*#__PURE__*/_jsx(TextSizeFriendlyDiv, {
        children: children
      })]
    })
  );
};
export default DescriptiveReportCard;